import React, { forwardRef, useEffect } from "react";
import "./signaturePad.scss";
import SignatureCanvas from "react-signature-canvas";
import { ButtonNew as Button} from "components/buttonNew";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
interface IProps {
    label?: string;
    height?: number;
    /**Colour of the pen stroke. Defaults to black */
    penColour?: string;
    onClear?: () => void;
    helpText?: string;
    disabled?: boolean;
    readOnly?: boolean;
}

const SignaturePad = forwardRef<SignatureCanvas, IProps>(
    ({ label, penColour = "black", height = 200, onClear, helpText, disabled, readOnly }, ref) => {
        const {t} = useTranslation();

        useEffect(() => {
            if (typeof ref !== "function") {
                if (disabled || readOnly) {
                    ref.current.off();
                } else {
                    ref.current.on();
                }
            }
        }, [disabled, readOnly]);

        return (
            <div className="ui-signature-pad">
                {label && <p className="ui-signature-pad-label">{label}</p>}
                <div className={classNames("ui-signature-pad-container", {"ui-signature-pad-container-disabled": disabled})}>
                <SignatureCanvas
                    ref={ref}
                    penColor={penColour}
                    canvasProps={{
                        className: "sigCanvas",
                        style: { width: "100%", height },
                    }}
                />
                </div>
                <div className="ui-signature-pad-footer">
                    <div className="ui-signature-pad-help-text">{helpText}</div>
                    {onClear && (!disabled && !readOnly) ? (
                        <Button type="secondary" size="small" onClick={onClear}>{t("Clear")}</Button>
                    ) :null}
                </div>
            </div>
        );
    },
);

SignaturePad.displayName = "SignaturePad";

export default SignaturePad;